<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="מדפסות M3250&rlm;, MS622">
     מדפסות M3250&rlm;, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_he" title="מידע בטיחותי">
     מידע בטיחותי
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href=".html#d0e23" title="מוסכמות">
      מוסכמות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="safety-power-cord-topic.html#d0e42" title="הצהרות בנוגע למוצר">
      הצהרות בנוגע למוצר
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_he" title="אודות המדפסת">
     אודות המדפסת
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_he" title="איתור מידע אודות המדפסת">
      איתור מידע אודות המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_he" title="בחירת מיקום עבור המדפסת">
      בחירת מיקום עבור המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printer-configurations-topic.html#printer-configurations_he" title="תצורות המדפסת">
      תצורות המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="attaching-cables-topic.html#attaching-cables_he" title="חיבור כבלים">
      חיבור כבלים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-control-panel-topic.html#using-control-panel_he" title="באמצעות לוח הבקרה">
      באמצעות לוח הבקרה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_he" title="הבנת מצב לחצן ההפעלה ונורית החיווי">
      הבנת מצב לחצן ההפעלה ונורית החיווי
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_he" title="הדפסת דף הגדרות הרשת">
      הדפסת דף הגדרות הרשת
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_he" title="הגדרה ושימוש באמצעות יישומי מסך הבית">
     הגדרה ושימוש באמצעות יישומי מסך הבית
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-home-screen-topic.html#using-home-screen_he" title="שימוש במסך הבית">
      שימוש במסך הבית
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_he" title="התאמה אישית של מסך הבית">
      התאמה אישית של מסך הבית
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-display-customization-topic.html#using-display-customization_he" title="שימוש בהתאמה אישית של התצוגה">
      שימוש בהתאמה אישית של התצוגה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_he" title="הגדרות מצב חיסכון">
      הגדרות מצב חיסכון
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-customer-support-topic.html#using-customer-support_he" title="שימוש בתמיכה ללקוחות">
      שימוש בתמיכה ללקוחות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_he" title="שימוש ביוצר קוד ה-QR">
      שימוש ביוצר קוד ה-QR
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_he" title="הגדרת מכסות בהתקן">
      הגדרת מכסות בהתקן
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_he" title="יצירת פרופיל Cloud Connector">
      יצירת פרופיל Cloud Connector
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="creating-bookmarks-topic.html#d0e1094" title="ניהול סימניות">
      ניהול סימניות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="adding-contacts-topic.html#d0e1171" title="ניהול אנשי קשר">
      ניהול אנשי קשר
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_he" title="הגדרת תכונות הנגישות והשימוש בהן">
     הגדרת תכונות הנגישות והשימוש בהן
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_he" title="הפעלת הדרכה קולית">
      הפעלת הדרכה קולית
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_he" title="ניווט במסך באמצעות תנועות ידיים">
      ניווט במסך באמצעות תנועות ידיים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_he" title="הפעלת מצב ההגדלה">
      הפעלת מצב ההגדלה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_he" title="כוון קצב הדיבור של ההדרכה הקולית">
      כוון קצב הדיבור של ההדרכה הקולית
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_he" title="שימוש במקלדת בתצוגה">
      שימוש במקלדת בתצוגה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_he" title="הפעלת סיסמאות קוליות או מספרי זיהוי אישיים קוליים">
      הפעלת סיסמאות קוליות או מספרי זיהוי אישיים קוליים
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_he" title="טעינת נייר ומדיה מיוחדת">
     טעינת נייר ומדיה מיוחדת
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_he" title="קביעת גודל וסוג הנייר">
      קביעת גודל וסוג הנייר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_he" title="הגדרת Universal Paper Size (גודל נייר אוניברסלי)">
      הגדרת Universal Paper Size (גודל נייר אוניברסלי)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="loading-trays-topic.html#loading-trays_he" title="טעינת מגשים">
      טעינת מגשים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_he" title="טעינה במזין הרב-תכליתי">
      טעינה במזין הרב-תכליתי
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_he" title="קישור בין מגשים">
      קישור בין מגשים
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_he" title="תומך נייר">
     תומך נייר
    </a>
   </p>
   <div id="divd0e1662">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_he" title="גודלי נייר נתמכים">
      גודלי נייר נתמכים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_he" title="סוגי נייר נתמכים">
      סוגי נייר נתמכים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_he" title="משקלי נייר נתמכים">
      משקלי נייר נתמכים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_he" title="נייר שאינו קביל">
      נייר שאינו קביל
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_he" title="שימוש בנייר ממוחזר">
      שימוש בנייר ממוחזר
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_he" title="הדפסה">
     הדפסה
    </a>
   </p>
   <div id="divd0e2520">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_he" title="הדפסה ממחשב">
      הדפסה ממחשב
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2546" title="הדפסה מהתקן נייד">
      הדפסה מהתקן נייד
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_he" title="הדפסה מכונן הבזק">
      הדפסה מכונן הבזק
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_he" title="כונני הבזק וסוגי קבצים נתמכים">
      כונני הבזק וסוגי קבצים נתמכים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_he" title="הגדרת משימות חסויות">
      הגדרת משימות חסויות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_he" title="הדפסת משימות חסויות ועבודות בהמתנה אחרות">
      הדפסת משימות חסויות ועבודות בהמתנה אחרות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_he" title="הדפסה מפרופיל Cloud Connector">
      הדפסה מפרופיל Cloud Connector
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_he" title="הדפסת רשימת דוגמאות גופנים">
      הדפסת רשימת דוגמאות גופנים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_he" title="הדפסת רשימת ספריות">
      הדפסת רשימת ספריות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="canceling-print-job-topic.html#canceling-print-job_he" title="ביטול משימת הדפסה">
      ביטול משימת הדפסה
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_he" title="הבנת תפריטי המדפסת">
     הבנת תפריטי המדפסת
    </a>
   </p>
   <div id="divd0e3058">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menu-map-topic.html#menu-map_he" title="Menu Map (מפת תפריטים)">
      Menu Map (מפת תפריטים)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="preferences-topic.html#d0e3377" title="Device (התקן)">
      Device (התקן)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="layout-topic.html#d0e5223" title="Print (הדפסה)">
      Print (הדפסה)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="tray-configuration-topic.html#d0e6481" title="Paper (נייר)">
      Paper (נייר)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="flash-drive-print-topic.html#d0e6743" title="USB Drive (כונן USB)">
      USB Drive (כונן USB)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="network-overview-topic.html#d0e6964" title="Network/Ports (רשת/יציאות)">
      Network/Ports (רשת/יציאות)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="login-methods-subgroup.html#d0e8754" title="Security (אבטחה)">
      Security (אבטחה)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menu-settings-page-topic.html#d0e9888" title="Reports (דוחות)">
      Reports (דוחות)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="help-topic.html#help_he" title="עזרה">
      עזרה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="troubleshooting-menu-topic.html#d0e10136" title="Troubleshooting (פתרון בעיות)">
      Troubleshooting (פתרון בעיות)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_he" title="הדפסת דף הגדרות התפריט">
      הדפסת דף הגדרות התפריט
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_he" title="אבטחת המדפסת">
     אבטחת המדפסת
    </a>
   </p>
   <div id="divd0e10188">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="locating-security-slot-topic.html#locating-security-slot_he" title="איתור חריץ האבטחה">
      איתור חריץ האבטחה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_he" title="מחיקת זיכרון המדפסת">
      מחיקת זיכרון המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_he" title="מחיקת זיכרון הכונן הקשיח של המדפסת">
      מחיקת זיכרון הכונן הקשיח של המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_he" title="הצפנת הדיסק הקשיח של המדפסת">
      הצפנת הדיסק הקשיח של המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_he" title="שחזור הגדרות ברירת המחדל של היצרן">
      שחזור הגדרות ברירת המחדל של היצרן
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_he" title="הצהרה על נדיפות">
      הצהרה על נדיפות
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_he" title="תחזוקת המדפסת">
     תחזוקת המדפסת
    </a>
   </p>
   <div id="divd0e10402">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_he" title="הגדרת התראות בדואר אלקטרוני">
      הגדרת התראות בדואר אלקטרוני
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_he" title="כוונון עוצמת הקול שנקבעה כברירת מחדל לאוזניות">
      כוונון עוצמת הקול שנקבעה כברירת מחדל לאוזניות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10466" title="עבודה ברשת">
      עבודה ברשת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_he" title="הגדרת הדפסה טורית (Windows בלבד)">
      הגדרת הדפסה טורית (Windows בלבד)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="cleaning-printer-topic.html#cleaning-printer_he" title="ניקוי המדפסת">
      ניקוי המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="ordering-supplies-group.html#ordering-supplies-group_he" title="הזמנת חלקים וחומרים מתכלים למדפסת">
      הזמנת חלקים וחומרים מתכלים למדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="replacing-toner-cartridge-topic.html#d0e11203" title="החלפת חלקים או חומרים מתכלים">
      החלפת חלקים או חומרים מתכלים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="moving-the-printer-group.html#d0e11347" title="העברת המדפסת">
      העברת המדפסת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="saving-energy-paper.html#d0e11403" title="חיסכון באנרגיה ובנייר">
      חיסכון באנרגיה ובנייר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="recycling.html#d0e11507" title="מיחזור">
      מיחזור
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_he" title="ניקוי חסימות">
     ניקוי חסימות
    </a>
   </p>
   <div id="divd0e11542">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="avoiding-jams-topic.html#avoiding-jams_he" title="הימנעות מחסימות נייר">
      הימנעות מחסימות נייר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_he" title="זיהוי מיקומי חסימות">
      זיהוי מיקומי חסימות
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_he" title="חסימת נייר בדלת A">
      חסימת נייר בדלת A
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_he" title="חסימת נייר בדלת האחורית">
      חסימת נייר בדלת האחורית
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_he" title="חסימת נייר בסל הסטנדרטי">
      חסימת נייר בסל הסטנדרטי
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_he" title="חסימת נייר ביחידת הדופלקס">
      חסימת נייר ביחידת הדופלקס
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_he" title="חסימת נייר במגשים">
      חסימת נייר במגשים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_he" title="חסימת נייר במזין הרב-תכליתי">
      חסימת נייר במזין הרב-תכליתי
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_he" title="Troubleshooting (פתרון בעיות)">
     Troubleshooting (פתרון בעיות)
    </a>
   </p>
   <div id="divd0e11818">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11821" title="בעיות חיבור לרשת">
      בעיות חיבור לרשת
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12135" title="בעיות באפשרויות חומרה">
      בעיות באפשרויות חומרה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12409" title="בעיות חומרים מתכלים">
      בעיות חומרים מתכלים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="solving-printer-problems.html#solving-printer-problems_he" title="בעיות הזנת נייר">
      בעיות הזנת נייר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="solving-printing-problems.html#solving-printing-problems_he" title="בעיות הדפסה">
      בעיות הדפסה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_he" title="יצירת קשר עם תמיכת הלקוחות">
      יצירת קשר עם תמיכת הלקוחות
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_he" title="שדרוג והעברה">
     שדרוג והעברה
    </a>
   </p>
   <div id="divd0e15401">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="available-internal-options-topic.html#d0e15404" title="חומרה">
      חומרה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="installing-printer-software-topic.html#d0e15714" title="תוכנה">
      תוכנה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15797" title="קושחה">
      קושחה
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_he" title="הודעות">
     הודעות
    </a>
   </p>
   <div id="divd0e15884">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e15887" title="מידע על המוצר">
      מידע על המוצר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e15904" title="הודעת מהדורה">
      הודעת מהדורה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#trademarks_he" title="סימנים מסחריים">
      סימנים מסחריים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#licensing-notices_he" title="הודעות לגבי רישיון">
      הודעות לגבי רישיון
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#noise-emission-levels_he" title="רמות פליטת רעש">
      רמות פליטת רעש
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e15999" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#product-disposal_he" title="השלכת מוצרים">
      השלכת מוצרים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_he" title="החזרת מכלי הדיו של Lexmark לשימוש חוזר או מיחזור">
      החזרת מכלי הדיו של Lexmark לשימוש חוזר או מיחזור
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#static-sensitivity-notice_he" title="הודעה על רגישות לחשמל סטטי">
      הודעה על רגישות לחשמל סטטי
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#energy-star_he" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#temperature-information_he" title="מידע טמפרטורה">
      מידע טמפרטורה
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#laser-notice_he" title="הודעה בנוגע ללייזר">
      הודעה בנוגע ללייזר
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#power-consumption_he" title="צריכת חשמל">
      צריכת חשמל
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e16235" title="הודעות תקינה עבור מוצרים אלחוטיים">
      הודעות תקינה עבור מוצרים אלחוטיים
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#modular-component-notice_he" title="הודעה לגבי רכיב מודולרי">
      הודעה לגבי רכיב מודולרי
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_he" title="חשיפה לקרינת תדר רדיו">
      חשיפה לקרינת תדר רדיו
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#radio-interference-notice_he" title="הודעה בדבר הפרעות רדיו">
      הודעה בדבר הפרעות רדיו
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue